export class DateHelper {
  public static toDateString(date: Date): string {
    return date.toLocaleDateString('nl-NL', {
      year: 'numeric', month: 'long', day: 'numeric'
    });
  }

  public static toTimeString(date: Date): string {
    return date.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });
  }

  public static toDateTimeString(date: Date): string {
    return `${DateHelper.toDateString(date)} ${DateHelper.toTimeString(date)}`;
  }
}
